import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum K1893InvoiceMeijerLineItemKeys {
  itemNumber = 'itemNumber',
  externalItemNumber = 'externalItemNumber',
  description = 'description',
  caseQtyOrdered = 'caseQtyOrdered',
  masterPack = 'masterPack',
  pack = 'pack',
  UoM = 'UoM',
  caseCost = 'caseCost',
  puAllowance = 'puAllowance',
  discountRate = 'discountRate',
  discountPrice = 'discountPrice',
  lineTotal = 'lineTotal',
}

export const k1893InvoiceMeijerFileDataSchema = yup.object({
  issuer: yup
    .object({
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      phoneNumber: yup.string().nullable().optional(),
      emailAddress: yup.string().nullable().optional(),
    })
    .required(),
  recipient: yup
    .object({
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      phoneNumber: yup.string().nullable().optional(),
      emailAddress: yup.string().nullable().optional(),
    })
    .required(),
  invoiceNumber: yup.string().nullable().optional(),
  associatedReferenceNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateDue: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  remittanceInstructions: yup
    .object({
      routingNumber: yup.string().nullable().optional(),
      accountNumber: yup.string().nullable().optional(),
      bankName: yup.string().nullable().optional(),
      bankAddress: yup.string().nullable().optional(),
      beneficiaryName: yup.string().nullable().optional(),
      beneficiaryAddress: yup.string().nullable().optional(),
      paymentLink: yup.string().nullable().optional(),
    })
    .required(),
  items: yup
    .array()
    .of(
      yup
        .object({
          [K1893InvoiceMeijerLineItemKeys.itemNumber]: yup.number().nullable().optional(),
          [K1893InvoiceMeijerLineItemKeys.externalItemNumber]: yup.string().nullable().optional(),
          [K1893InvoiceMeijerLineItemKeys.description]: yup.string().nullable().optional(),
          [K1893InvoiceMeijerLineItemKeys.caseQtyOrdered]: yup.string().nullable().optional(),
          [K1893InvoiceMeijerLineItemKeys.masterPack]: yup.string().nullable().optional(),
          [K1893InvoiceMeijerLineItemKeys.pack]: yup.string().nullable().optional(),
          [K1893InvoiceMeijerLineItemKeys.UoM]: yup.string().nullable().optional(),
          [K1893InvoiceMeijerLineItemKeys.caseCost]: yup.string().nullable().optional(),
          [K1893InvoiceMeijerLineItemKeys.puAllowance]: yup.string().nullable().optional(),
          [K1893InvoiceMeijerLineItemKeys.discountRate]: yup.string().nullable().optional(),
          [K1893InvoiceMeijerLineItemKeys.discountPrice]: yup.string().nullable().optional(),
          [K1893InvoiceMeijerLineItemKeys.lineTotal]: yup.string().nullable().optional(),
        })
        .required(),
    )
    .required(),
  agreement: yup.string().nullable().optional(),
  comments: yup.string().nullable().optional(),
})

export type K1893InvoiceMeijerFileData = yup.InferType<typeof k1893InvoiceMeijerFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<K1893InvoiceMeijerFileData>

export const k1893InvoiceMeijerFileMappings: RequiredFileData = {
  issuer: {
    companyName: '7d7f7c78-7b04-4b8b-8bf8-e6d6ff9fae9c',
    addressLine1: '0c8a6f6c-c2d2-4941-924f-979bbf0de7d2',
    phoneNumber: '40b56c28-9edd-4baf-bc57-de1cd8d48c4f',
    emailAddress: 'dcc5c53e-aa7c-4d62-b24e-d862a6e1f0c3',
  },
  recipient: {
    companyName: 'f7a23dae-e0ff-4a34-ba76-9b69ba72c8c1',
    addressLine1: '3ccd622a-f02f-4e8b-b1b5-d51a41731a4e',
    phoneNumber: '34975951-8cc7-4efd-8f69-f90b66764ecd',
    emailAddress: '3f2c03a5-c8dd-4a96-9f8e-7b25b22fdeaf',
  },
  invoiceNumber: 'b8e8c2d9-e744-48f7-96d1-0f2ad6e86acb',
  associatedReferenceNumber: 'b0ff2b41-4738-4c07-8ee7-ac64bc84fc3e',
  dateIssued: '37630395-6cea-4d9c-b9c8-f98e0d3f9a20',
  dateDue: '0a3ac769-c2c5-4858-8aef-b1f3d9af7a8d',
  paymentTerms: 'e0b8bf53-5d47-4d5c-bc12-c48be43e4753',
  freightTerms: '34a01dff-4e17-4c60-9ab2-ffe3551c5ef2',
  remittanceInstructions: {
    routingNumber: 'e9a4e39d-e1f6-4099-8fb3-be4a78c0d89b',
    accountNumber: '34af8df3-7df7-464d-9ea6-b3b6dcc98bcf',
    bankName: 'c32cdbd6-c6fc-44df-935b-a884b6f79fa7',
    bankAddress: '462e64b4-a2d2-4532-aeef-1e2953ebf508',
    beneficiaryName: '62e8fda0-65ea-4fbd-9921-24fd5a3a6389',
    beneficiaryAddress: 'ac3a58e5-3ef3-4d4f-8adf-06c8ad2f0faf',
    paymentLink: '8d2c82df-ece3-4aee-ad95-46a31d37a7d3',
  },
  items: [
    {
      itemNumber: null,
      externalItemNumber: '4e00f05e-5d84-4a93-90e1-5d8a5cf5b8c4',
      description: 'f8ca2faf-bc40-46e6-9d18-de08c0f2f837',
      caseQtyOrdered: 'b86adfab-df08-4a4f-9fea-aac2d32a66dc',
      masterPack: 'e4feb4a7-cf1e-4f56-89b3-a5f23687f82e',
      pack: '587b2ea0-2f66-4770-b69b-55f8cbfe4a89',
      UoM: '11e7a58e-5b8c-4943-89cf-dfbdd4ee62b5',
      caseCost: 'b1f6c08a-fae3-4de7-a5f5-97db5786d03d',
      puAllowance: '73855dea-a4a5-41e7-ae51-5ff71721e5da',
      discountRate: 'f3b0a2d4-5c7e-4f8b-9a1c-6d0e2f3b5c8d',
      discountPrice: null,
      lineTotal: null,
    },
  ],
  agreement: '2b5b0fe3-8d20-4ae9-998f-c9e50a9c1f65',
  comments: '755a3a91-62ee-4ce3-bab5-71cf3c9ffd04',
}
